import {GeneralRedirect, IRoutesProvider } from 'Shared/Routes';
import { sharedLoginRoutes } from 'Shared/routes/LoginRoutes';
import { lazy } from 'solid-js';


export class ArtistRoutes implements IRoutesProvider
{
	routes()
	{
		return ([
			{
				path: '/',
				component: () => <GeneralRedirect url='/login' />
			},
			{
				path: '/login',
				component: lazy(() => import('Shared/users/LoginPage')),
			},
			...sharedLoginRoutes(),

			{
				path: '/',
				component: lazy(() => import('Shared/artists/Wrap')),

				children: [
					{
						path: '/manager',
						component: lazy(() => import('Shared/artists/ManagerPage')),
					},
					{
						path: '/profile/:id',
						component: lazy(() => import('Shared/artists/ProfilePage')),
					},
					{
						path: '/user',
						component: lazy(() => import('Shared/artists/UserPage')),
					},
				]
			},
			{
		
				path: '/*',
				component: PageNotFoundPage,
				//NOTE Solid Start has a way to do this built in. Doesn't matter enough to bother with for the moment.
//				code: 400
			}
		]);
	}

//TODO maybe trim trailing / from all...
}

function PageNotFoundPage()
{
	return (
		<p>
			Sorry, no such page.
		</p>
	);
}
